import { FC } from 'react';
import { Amount } from '@mews-commander/types';
import { TextKey } from '@mews-commander/enums';
import { LocalizedCurrencyValue, LocalizedText } from '@mews/framework';
import { Highlight, Stack, Typography } from '@optimus-web/core';
import { LocalizedLabel, LocalizedMinorHighlight } from '@mews-commander/ui';
import { getPositiveAmount } from '@mews-commander/utils';
import { AmountDue } from '../AmountDue';

interface NewAccountBalanceProps {
    amount?: Amount;
}

const NewAccountBalance: FC<NewAccountBalanceProps> = ({ amount }) => {
    if (!amount) return null;
    const { currency, value, netValue } = amount;

    if (value === 0) {
        return <LocalizedMinorHighlight textKey={TextKey.Balanced} />;
    }

    if (value < 0) {
        return (
            <Stack spacing="100" itemAlignment="center">
                <LocalizedLabel textKey={TextKey.ToBeRefunded} as="div" />
                <AmountDue isNegative value={getPositiveAmount(amount)} />
            </Stack>
        );
    }

    return (
        <Stack spacing="300" itemAlignment="center">
            <Stack spacing="50">
                <Typography textStyle="bodyMedium" variant="secondary" as="div">
                    <LocalizedText textKey={TextKey.SubTotal} />
                </Typography>
                <Typography textStyle="bodyMediumStrong" as="div">
                    <LocalizedCurrencyValue value={{ value: netValue, currency }} />
                </Typography>
            </Stack>
            <Stack spacing="50">
                <Typography textStyle="bodyMedium" variant="secondary" as="div">
                    <LocalizedText textKey={TextKey.Tax} />
                </Typography>
                <Typography textStyle="bodyMediumStrong" as="div">
                    <LocalizedCurrencyValue value={{ value: value - netValue, currency }} />
                </Typography>
            </Stack>
            <Stack itemAlignment="center" spacing="50">
                <Typography textStyle="bodyMedium" variant="secondary" as="div">
                    <LocalizedText textKey={TextKey.ToBePaidInclTax} />
                </Typography>
                <Highlight size="large">
                    <LocalizedCurrencyValue value={{ value, currency }} />
                </Highlight>
            </Stack>
        </Stack>
    );
};

export default NewAccountBalance;
